import { Fancybox } from '@fancyapps/ui/dist/fancybox/'

document.addEventListener('DOMContentLoaded', () => {

  Fancybox.bind('[data-fancybox]')
})